<template>
	<v-card class="settings-page" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-alert v-model="successMessage" type="success" dismissible>
				Settings saved successfully.
			</v-alert>
			<v-alert v-model="errorMessage" type="error" dismissible> An error occurred. </v-alert>

			<v-card-text v-if="isPageVisible">
				<v-list class="settings-page__item-wrapper pa-4">
					<v-list-item class="settings-page__item" v-if="termOfUse">
						<v-list-item-content class="pa-0">
							<a class="text-decoration-none" :href="termOfUse" target="_blank">
								Terms of Use
							</a>
						</v-list-item-content>
					</v-list-item>

					<v-list-item class="settings-page__item" v-if="privacyPolicy">
						<v-list-item-content class="pa-0">
							<a class="text-decoration-none" :href="privacyPolicy" target="_blank">
								Privacy Policy
							</a>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-card-text>
			<div v-if="cleanVersion" class="settings-page__version">
				Version:
				<span class="settings-page__version__number">
					{{ cleanVersion }}
				</span>
			</div>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import LocalStorageService from '@/services/local-storage.service'

export default {
	name: 'SettingsPage',
	mixins: [Block],
	components: {
		PageBlocked,
	},
	computed: {
		...mapGetters('settings', ['settings', 'baseCore', 'appCore']),
		...mapGetters('auth', ['profile']),
		additionalUserSettings() {
			const raw = LocalStorageService.get('additionalLoginSettings')
			if (!raw) return {}
			try {
				return JSON.parse(raw)
			} catch (e) {
				console.warn('e', e)
				return {}
			}
		},
		privacyPolicy() {
			const { privacy_policy: value } = this.additionalUserSettings || {}
			return value
		},
		termOfUse() {
			const { terms_of_use: value } = this.additionalUserSettings || {}
			return value
		},

		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		cleanVersion() {
			return (
				(process.env.VUE_APP_VERSION || '') +
				(process.env.VUE_APP_BUILD_NUMBER ? ` (${process.env.VUE_APP_BUILD_NUMBER})` : '')
			)
		},
		isPageVisible() {
			if (!this.baseCore) {
				return null
			}
			return (
				this.baseCore.privacy_policy ||
				this.baseCore.terms_of_use ||
				this.baseCore.contact_us_url
			)
		},
	},
	watch: {
		baseCore(newValue) {
			if (
				newValue &&
				!newValue.privacy_policy &&
				!newValue.terms_of_use &&
				!newValue.contact_us_url
			) {
				this.$router.back()
			}
		},
	},
	methods: {
		...mapActions('settings', ['fetchSettings', 'getBaseCoreSettings']),
		...mapActions('app', ['setPageTitle']),
		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		getRoute(initValue) {
			const url = new URL(initValue)
			return url.pathname
		},
	},
	data() {
		return {
			successMessage: false,
			errorMessage: false,
			pageBlockedName: 'settings',
		}
	},
	mounted() {
		this.setPageTitle('Settings')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		this.getBaseCoreSettings()
	},
}
</script>

<style lang="scss">
.settings-page {
	font-family: 'Inter', sans-serif;
	max-width: 555px;
	width: 100%;
	background-color: transparent !important;

	&__item {
		min-height: auto;

		a {
			font-size: 14px !important;
			line-height: 17.07px;
			font-weight: 700;
			color: var(--ceil-detail-text-color) !important;
		}

		&-wrapper {
			display: flex;
			flex-direction: column;
			row-gap: 12px;
			border-radius: 8px !important;
			border: 1px solid #e2e2e2 !important;
		}
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
	}
	&__version {
		font-family: 'Inter', sans-serif;
		color: #9b9b9b;
		font-weight: 700;
		font-size: 12px;
		line-height: 20px;
		letter-spacing: 0;
		position: fixed;
		bottom: 20px;
		padding-left: 250px;
		&__number {
			color: #9b9b9b;
			font-weight: 400;
			font-size: 10px;
			line-height: 20px;
			letter-spacing: 0;
		}
	}
}
</style>
